<!-- grid of product variants -->
<ng-template #productVariants let-isSizeSelector>
    <div
        [class.product-variants-revamp]="isProductRevampSelectorEnabled && !isSizeSelector"
        [class.product-variants-norevamp]="!isProductRevampSelectorEnabled && !isSizeSelector"
        [class.product-variants-new-size-selector]="isSizeSelector"
        [attr.role]="!isSizeSelector ? 'list' : 'radiogroup'"
        [attr.aria-labelledby]="labelledById">
        @for(variant of initialVariants; let idx = $index; track variant.sku) {
        <div class="variant-box" [attr.role]="!isSizeSelector ? 'listitem' : ''">
            <!-- if last of list, surround with show more button -->
            @if(shouldWrapWithShowMore(idx) && isVariantWithImage(variant)) {
            <h-show-more
                (pressed)="toggleHasMore()"
                [moreNumber]="hiddenVariants.length + 1"
                [focusable]="true"
                [isLightBackground]="isProductRevampSelectorEnabled">
                <!-- In browser mode use lazy loading -->
                @if (!isProductRevampSelectorEnabled) { @if(!isInServerMode()) {
                <picture class="picture">
                    <!-- TODO delete when flag product_page_selector_revamp is true-->
                    <source
                        [media]="pageProductImageMediaqueries.Mobile"
                        [srcset]="getScene7Url(imageSizeOnMobile, variant.image, true)" />
                    <source
                        [media]="pageProductImageMediaqueries.Tablet"
                        [srcset]="getScene7Url(imageSizeOnMobile, variant.image, true)" />
                    <source
                        [media]="pageProductImageMediaqueries.Desktop"
                        [srcset]="getScene7Url(imageSizeOnDesktop, variant.image, true)" />
                    @if(variant.image) { @switch(type) { @case('buckle') {
                    <img
                        [src]="getScene7Url(thumbnailSize, variant.image, false)"
                        class="variant-responsive"
                        i18n-alt="@@hermes.accessibility.show-all-buckles"
                        loading="lazy"
                        alt="{{ moreVariants }} more buckles, show all" />
                    } @default {
                    <img
                        [src]="getScene7Url(thumbnailSize, variant.image, false)"
                        class="variant-responsive"
                        loading="lazy"
                        i18n-alt="@@hermes.accessibility.page-product.show-more-colors"
                        alt="{{ moreVariants }} more colors, show all" />
                    } } }
                </picture>
                }

                <!-- In server mode use default image for SEO -->
                @if(isInServerMode()) {
                <noscript class="variant-responsive">
                    @switch(type) { @case('buckle') {
                    <img
                        [src]="getScene7Url(thumbnailSize, variant.image, false)"
                        class="variant-responsive"
                        i18n-alt="@@hermes.accessibility.show-all-buckles"
                        alt="{{ moreVariants }} more buckles, show all" />
                    } @default {
                    <img
                        [src]="getScene7Url(thumbnailSize, variant.image, false)"
                        class="variant-responsive"
                        i18n-alt="@@hermes.accessibility.page-product.show-more-colors"
                        alt="{{ moreVariants }} more colors, show all" />
                    } }
                </noscript>

                } } @else {
                <picture class="picture">
                    <source
                        [media]="pageProductImageMediaqueries.Mobile"
                        [srcset]="getScene7Url(imageSizeOnMobile, variant.image, true)" />
                    <source
                        [media]="pageProductImageMediaqueries.Tablet"
                        [srcset]="getScene7Url(imageSizeOnTablet, variant.image, true)" />
                    <source
                        [media]="pageProductImageMediaqueries.Desktop"
                        [srcset]="getScene7Url(imageSizeOnDesktop, variant.image, true)" />
                    @if(variant.image) { @switch(type) { @case('buckle') {
                    <img
                        [src]="getScene7Url(thumbnailSize, variant.image, false)"
                        class="variant-responsive"
                        i18n-alt="@@hermes.accessibility.show-all-buckles"
                        loading="lazy"
                        [width]="imageSizeOnTablet"
                        [height]="imageSizeOnTablet"
                        alt="{{ moreVariants }} more buckles, show all" />
                    } @default {
                    <img
                        [src]="getScene7Url(thumbnailSize, variant.image, false)"
                        class="variant-responsive"
                        loading="lazy"
                        [width]="imageSizeOnTablet"
                        [height]="imageSizeOnTablet"
                        i18n-alt="@@hermes.accessibility.page-product.show-more-colors"
                        alt="{{ moreVariants }} more colors, show all" />
                    } } }
                </picture>
                }
            </h-show-more>
            } @else { @if(isSizeSelector) {
            <h-variant-item
                class="variant-item"
                [boxType]="'radio'"
                [variant]="variant"
                [hasSizeVariants]="hasSizeVariants"
                [areAllSizeVariantsOutOfStock]="areAllSizeVariantsOutOfStock"
                [variantType]="type"
                [formGroup]="parentForm"
                [formName]="type"
                [inputId]="'variant-item-' + getSkuToId(variant.sku) + '-' + type"
                [selectedValue]="selectedValue"
                [hasFixedWidth]="true"
                [isThinBorder]="isThinBorder"
                [routing]="true">
            </h-variant-item>
            } @else {
            <h-variant-item
                [boxType]="currentProduct.sku === variant.sku ? 'none' : 'link'"
                id="{{ type }}{{ idx }}"
                [variant]="variant"
                [currentProduct]="currentProduct"
                [imageSrc]="isVariantWithImage(variant) ? variant.image : ''"
                [variantType]="type"
                [formGroup]="parentForm"
                [formName]="type"
                [routing]="true"
                [isThinBorder]="isThinBorder"
                [inputId]="'variant-item-' + getSkuToId(variant.sku) + '-' + type"
                [selectedValue]="selectedValue">
            </h-variant-item>
            } }
        </div>
        } @if(showAllVariants && moreVariantsEnabled && hiddenVariants.length) { @for(variant of hiddenVariants; let idx
        = $index; track variant.sku) { @if(isVariantWithImage(variant)) {
        <div class="variant-box">
            <h-variant-item
                [boxType]="currentProduct.sku === variant.sku ? 'none' : 'link'"
                [variant]="variant"
                [currentProduct]="currentProduct"
                [imageSrc]="variant.image"
                [variantType]="type"
                [hasSizeVariants]="hasSizeVariants"
                [areAllSizeVariantsOutOfStock]="areAllSizeVariantsOutOfStock"
                [formGroup]="parentForm"
                [selectedValue]="selectedValue"
                [isThinBorder]="isThinBorder"
                [routing]="true">
            </h-variant-item>
        </div>
        } } }
    </div>
</ng-template>
<ng-container *ngTemplateOutlet="productVariants; context: { $implicit: type === 'size' || type === 'strapSize' }">
</ng-container>
